export enum QuoteStatus {
    created = 'created',
    approved = 'approved',
    cancelled = 'cancelled',
}
